

/**
 * @ngdoc service
 * @name app.urlUtils
 * @description
 * # api
 * Service in the app.
 */
angular.module('app')
	.service('UrlUtils', [
		'$location',
		function ($location) {
			let hasQuery = function () {
				return $location.url().match(/\?/);
			};

			let removeField = function (key) {
				let regExp = new RegExp(key + '=(.*&|.*$)', 'g');
				return $location.url().replace(regExp, '');
			};

			let setField = function (field, value) {
				if (!hasQuery()) {
					$location.url($location.url() + '?' + field + '=' + value);
				}
				else {
					let urlWithNoField = removeField(field);
					let dest = urlWithNoField + (urlWithNoField.match(/\?.+/) ? '&' + field + '=' + value : field + '=' + value);
					history.pushState('', '', dest);
					//$location.url( dest );
				}
			};

			return {
				setField: setField,
			};
		},
	]);
